import React from 'react';
import {useState} from 'react';
import style from './MagicReply.module.scss';
import {MarkdownViewer} from '../MarkdownViewer/MarkdownViewer';
import MagicReplyLogo from '../../../public/MagicReplyLogo.svg';
import MinimizeIcon from '../../../public/MinimizeIcon.svg';
import NewChatIcon from '../../../public/NewChatIcon.svg';

export const MagicReply = ({conversateWithMagicReply, showToast}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [size, setSize] = useState({width: 350, height: 600});
    const [position, setPosition] = useState({x: window.innerWidth * 0.74, y: window.innerHeight * 0.31955});
    const [chatHistory, setChatHistory] = useState([]);
    const [conversation, setConversation] = useState([]);
    const [userInput, setUserInput] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleDrag = (e) => {
        e.preventDefault();
        const startX = e.clientX - position.x;
        const startY = e.clientY - position.y;

        const onMouseMove = (event) => {
            setPosition({
                x: event.clientX - startX,
                y: event.clientY - startY,
            });
        };

        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };

    const handleResize = (e) => {
        e.preventDefault();
        const startWidth = size.width;
        const startHeight = size.height;
        const startX = e.clientX;
        const startY = e.clientY;

        const onMouseMove = (event) => {
            setSize({
                width: Math.max(200, startWidth + (event.clientX - startX)),
                height: Math.max(200, startHeight + (event.clientY - startY)),
            });
        };

        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };

    const handleSendMessage = async () => {
        if (!userInput.trim()) return;

        const newMessage = {
            inputs: {
                question: userInput,
                k: 3
            }
        };

        const updatedChatHistory = chatHistory.length > 0
            ? [{...newMessage, outputs: chatHistory[chatHistory.length - 1].outputs}]
            : [];

        setUserInput('');
        setIsLoading(true);
        setConversation((prev) => [...prev, {role: 'User', message: userInput}]);

        try {
            const payload = {
                chat_history: updatedChatHistory,
                question: userInput,
                k: 3
            }
            const data = await conversateWithMagicReply(payload);
            const chatHistoryEntry = {
                inputs: {question: userInput, k: 3},
                outputs: {answer: data.response.answer}
            };
            setConversation((prev) => [...prev, {role: 'MagicReply', message: data.response.answer}]);
            setChatHistory((prev) => [...prev, chatHistoryEntry]);
        } catch (error) {
            showToast(`Error al enviar mensaje`, true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    return (
        <div>
            <button className={`${style.chatButton} ${isOpen ? style.opaqueChatButton : ''}`} onClick={() => setIsOpen(true)}>
                <img src={MagicReplyLogo} alt="MagicReplyLogo" />
            </button>

            {isOpen && (
                <div style={{width: size.width, height: size.height, left: position.x, top: position.y}} className={style.chatContainer}>
                    <div className={style.chatHeaderBodyFooterContainer}>
                        <div className={style.chatHeader} onMouseDown={handleDrag}>
                            Magic Reply
                            <div className={style.chatMinimize} onClick={() => {
                                setIsOpen(false)
                            }}>
                                <img src={MinimizeIcon} alt="MinimizeIcon" />
                            </div>

                        </div>

                        <div className={style.chatBody}>
                            {conversation.map((entry, index) => (
                                <div key={index} className={`${style.entryContainer} ${style[`entryContainer${entry.role}`]}`}>
                                    <div className={`${style.message} ${style[entry.role]}`}>
                                        <MarkdownViewer markdownText={entry.message} />
                                    </div>
                                </div>
                            ))}
                            {isLoading && (
                                <div className={style.typingIndicator}>
                                    <span className={style.dot}>.</span>
                                    <span className={style.dot}>.</span>
                                    <span className={style.dot}>.</span>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className={style.chatFooter}>
                        <div className={style.newChatIconContainer}>
                            <div className={style.tooltip}>Start a new chat</div>
                            <div onClick={() => {
                                setConversation([]);
                                setChatHistory([]);
                            }}>
                               <img src={NewChatIcon} alt="NewChatIcon" />
                            </div>
                        </div>
                        <input
                            type="text"
                            value={userInput}
                            onChange={(e) => setUserInput(e.target.value)}
                            onKeyDown={handleKeyPress}
                            placeholder="Write a message..."
                        />
                        <div className={style.buttonContainer}>
                            <button className={style.sendButton} onClick={handleSendMessage}>Send</button>
                        </div>
                    </div>

                    <div className={style.chatResizer} onMouseDown={handleResize}></div>
                </div>
            )}
        </div>
    );
};

